import React from 'react';

/**
 * Edited dot for data points that have been modified
 * Uses the series stroke color but with an amber fill to indicate edited state
 */
const EditedDot = (props) => {
  const { cx, cy, stroke, className, onClick } = props;

  return (
    <g
      className={className}
      onClick={onClick}
      style={{ cursor: 'pointer' }}
    >
      <circle
        cx={cx}
        cy={cy}
        r={8}
        stroke={stroke || '#8884d8'}
        strokeWidth={2}
        fill="#FFE0B2"
      />
    </g>
  );
};

export default EditedDot;
